import SmsService from "./services/service";
import smsEditor from "./directives/directive";
import TextMessage from "./textMessage.repository";

export default angular.module('app.smseditor', [])
    .directive('smsEditor', () => new smsEditor)
    .service('SmsService', SmsService)
    .service('TextMessage', TextMessage)
    .name;

